import * as React from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Container, Grid,
  MenuItem, CircularProgress, Box, IconButton, Typography,
  Stack, Pagination, Checkbox, Fab,
} from "@mui/material";
import { Refresh, CheckBox, CheckBoxOutlineBlank, PhotoCamera } from "@mui/icons-material";
import {H2, H3, H4, H5, H6, SpanInline} from 'components/CustomTypography';
import CustomFlexBox from 'components/CustomFlexBox';

import {
  Button,
  Notification,
  AutoComplete,
  Divider,
} from "components/Atoms";

import UnifiedPullToRefresh from "components/elements/main/UnifiedPullToRefresh";

import * as Actions from "actions";
import * as ActionTypes from "constants/ActionTypes";

import SellerCategorySelector from "components/elements/seller/SellerCategorySelector";
import PrivateProductEditor from "components/elements/seller/PrivateProductEditor";
import SellerProductEntryForm from "components/elements/seller/SellerProductEntryForm";
import SellerProduct from "components/elements/seller/SellerProduct";
import ModelTryOnSelector from "components/elements/seller/ModelTryOnSelector";

import PrivateProductImageMain from "components/pages/seller/products/PrivateProductImageMain";
import PrivateProductQuickAddMain from "components/pages/seller/products/PrivateProductQuickAddMain";

import MockProductList from "components/elements/main/MockProductList";

import { CURRENCY } from "config/constants";

import "./style.scss";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ButtonComponent from "components/Button";
import SellerProductStatusSelector from "components/elements/seller/SellerProductStatusSelector";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PrivateCategoryMain from "../PrivateCategoryMain";
import CustomSectionCreator from "../../../../CustomSectionCreator";

const { Option } = AutoComplete;

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
        {value === index && (
            <Box>
              <Typography>{children}</Typography>
            </Box>
        )}
      </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


const PrivateProductsMain = (props) => {
  const [state, setState] = useState({ productMode: "PREVIEW" });
  const [categoryState, setCategoryState] = useState({ selectedCategory: (props.categoryInput ? props.categoryInput : null) });
  const [productState, setProductState] = useState({ storeProduct: "" });
  const [offsetState, setOffsetState] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [productStatusState, setProductStatusState] = useState("new");
  const [activeFilterState, setActiveFilterState] = useState("all"); // all, active, inactive
  const [value, setValue] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showModelSelector, setShowModelSelector] = useState(false);

  const {
    serviceError, reqStatus, isLoading, storeProducts, categoryList, symbol, currency,
    getStoreProductCategories, getStoreProducts, shop, systemModels, isLoadingModels,
    isGeneratingTryOn, getSystemModels, bulkGenerateModelTryOn, tryonCredits, getTryOnCredits
  } = props;

  useEffect(() => {
    getStoreProductCategories();
    getStoreProducts(null, true, "new", 1, activeFilterState);
  }, []);

  const handleRefresh = () => {
    setOffsetState(1);
    setProductStatusState(productStatusState);
    setActiveFilterState(activeFilterState);
    getStoreProducts(categoryState.selectedCategory, true, productStatusState, offsetState, activeFilterState);
  };

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (serviceError && reqStatus) {
      const feedback = {
        title: props.serviceError,
        description: props.serviceError.statusText,
      };
      sendNotification("success", feedback);
    }
    switch (reqStatus) {
      case ActionTypes.ADD_PRIVATE_PRODUCT_IMAGE_QUICK_SUCCESS:
      case ActionTypes.ADD_PRIVATE_PRODUCT_VIDEO_QUICK_SUCCESS:
      case ActionTypes.GENERATE_MODEL_TRYON_SUCCESS:
        setState({ productMode: "PREVIEW" });
      case ActionTypes.ADD_PRIVATE_PRODUCT_SUCCESS:
      case ActionTypes.UPDATE_PRIVATE_PRODUCT_SUCCESS:
      case ActionTypes.ADD_PRIVATE_PRODUCT_IMAGE_SUCCESS:
      case ActionTypes.REMOVE_PRIVATE_PRODUCT_IMAGE_SUCCESS:
      case ActionTypes.UPDATE_PRODUCT_SUCCESS:
        getStoreProducts(categoryState.selectedCategory, true, productStatusState, offsetState, activeFilterState);
        break;
      case ActionTypes.BULK_GENERATE_MODEL_TRYON_SUCCESS:
        setSelectedProducts([]);
        setShowModelSelector(false);
        getStoreProducts(categoryState.selectedCategory, true, productStatusState, offsetState, activeFilterState);
        getTryOnCredits();
        break;
      default:
        break;
    }
  }, [serviceError, reqStatus]);

  const addUpdateProductToAccountCall = (values) => {
    if (!values.product_id) {
      props.addPrivateProduct(values);
    } else {
      props.updatePrivateProduct(values);
    }
    setState({ productMode: "PREVIEW" });
  };

  const updateProductSettingCall = (values, id) => {
    values.id = id;
    props.updateProduct(values);
    setState({ productMode: "PREVIEW" });
  };

  const handleToggleProductActive = (listingId, newActiveStatus) => {
    const values = {
      id: listingId,
      is_active: newActiveStatus,
    };
    props.toggleProductActiveStatus(values);
  };

  const handleProductEdit = (mode, item, reset) => (e) => {
    setState({ productMode: mode });
    if (reset) {
      setProductState({
        storeProduct: {
          name: "",
          price: "",
          minqty: 1,
          description: "",
          category: "",
          is_food: false,
          is_nonveg: false,
          id: "",
          prod_id: "",
          product_id: "",
          listing_id: "",
          images: [],
          size: [],
        },
      });
    } else {
      item.category = item.categories.length > 0 ? item.categories[0]._id : "NA";
      setProductState({
        storeProduct: {
          name: item.name,
          description: item.description,
          category: item.category,
          is_food: item.is_food,
          is_nonveg: item.is_nonveg,
          price: item.price,
          minqty: item.minqty ? item.minqty : 1,
          id: item.id,
          prod_id: item.prod_id,
          product_id: item.product_id,
          listing_id: item.listing_id,
          images: item.images,
          size: item.size,
        },
      });
    }
  };

  const handleProductEditing = (mode, item) => (e) => {

    setValue(0);
    setState({ productMode: mode });

    setProductState({
      storeProduct: {
        name: item.name,
        description: item.description,
        category: item.category,
        price: item.price,
        minqty: item.minqty ? item.minqty : 1,
        id: item.id,
        prod_id: item.prod_id,
        product_id: item.product_id,
        listing_id: item.listing_id,
        is_popular: item.is_popular,
        is_price_visible: item.is_price_visible,
        is_price_onunlock: item.is_price_onunlock,
        is_listing_active: item.is_listing_active,
        in_stock: item.in_stock,
        is_food: item.is_food,
        is_nonveg: item.is_nonveg,
        size: item.size,
        images: item.images,
      },
    });
  };

  const history = useHistory();

  const handlePage = (page) => (e) => {
    history.push(page);
  };

  const resetCategory = () => {
    setCategoryState({ selectedCategory: null });
    setOffsetState(1);
    getStoreProducts(null, true, productStatusState, 1, activeFilterState);
  };

  const setCategory = (category) => {
    setCategoryState({ selectedCategory: category.id });
    setOffsetState(1);
    getStoreProducts(category.id, true, productStatusState, 1, activeFilterState);
  };

  const setProductStatus = (status) => {
    setProductStatusState(status);
    setOffsetState(1);
    getStoreProducts(categoryState.selectedCategory, true, status, 1, activeFilterState);
  };

  const setActiveFilter = (filter) => {
    setActiveFilterState(filter);
    setOffsetState(1);
    getStoreProducts(categoryState.selectedCategory, true, productStatusState, 1, filter);
  };

  const handleRestAll = () => {
    setOffsetState(1);
    setProductStatusState("");
    setActiveFilterState("all");
    setCategoryState({ selectedCategory: null });
    getStoreProducts(null, true, "", 1, "all");
  };

  const handlePrevOffset = () => {
    const offset = offsetState > 1 ? offsetState - 1 : 1;
    setOffsetState(offset);
    getStoreProducts(categoryState.selectedCategory, true, productStatusState, offset, activeFilterState);
  };

  const handleNextOffset = () => {
    const offset = offsetState + 1;
    setOffsetState(offset);
    getStoreProducts(categoryState.selectedCategory, true, productStatusState, offset, activeFilterState);
  };

  const handlePageChange = (event, value) => {
    setOffsetState(value);
    getStoreProducts(categoryState.selectedCategory, true, productStatusState, value, activeFilterState);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleProductSelect = (productId) => {
    setSelectedProducts(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedProducts.length === records.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(records.map(p => p.product_id));
    }
  };

  const handleOpenModelSelector = () => {
    if (!systemModels || systemModels.length === 0) {
      getSystemModels();
    }
    setShowModelSelector(true);
  };

  const handleCloseModelSelector = () => {
    setShowModelSelector(false);
  };

  const handleSelectModel = (modelId) => {
    if (selectedProducts.length === 0) {
      sendNotification("warning", {
        title: "No Products Selected",
        description: "Please select at least one product to generate model try-ons."
      });
      return;
    }

    // modelId can be null for auto-selection or a specific model ID
    bulkGenerateModelTryOn(selectedProducts, modelId);
  };

  const { records, pagination } = storeProducts;
  const { categories } = categoryList;
  const { productMode } = state;
  const { storeProduct = {} } = productState;
  const { selectedCategory = {} } = categoryState;

  const inputOptions = categories.map((item) => {
    const { id, name } = item;
    return (
      <MenuItem value={id}>{name}</MenuItem>
    );
  });

  const renderNoResults = () => (
    <section className="cart-section section-b-space">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div>
              <div className="col-sm-12 empty-cart-cls text-center">
                <H6>No product found
                </H6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const renderResults = () => (
        <div>
              {records.length > 0
                      ? (
                          <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2}>
                            {records.map((product, index) => (
                                <Grid item xs={6} sm={3} md={3} lg={3} key={index} sx={{ position: 'relative' }}>
                                    <Checkbox
                                      checked={selectedProducts.includes(product.product_id)}
                                      onChange={() => handleProductSelect(product.product_id)}
                                      sx={{
                                        position: 'absolute',
                                        top: 8,
                                        left: 8,
                                        zIndex: 10,
                                        backgroundColor: 'white',
                                        borderRadius: '4px',
                                        '&:hover': {
                                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        }
                                      }}
                                    />
                                  <SellerProduct
                                      className="product-item"
                                      symbol={symbol}
                                      currency={currency}
                                      key={product.id}
                                      product={product}
                                      editProduct={handleProductEditing("EDIT", product)}
                                      onToggleActive={handleToggleProductActive}
                                  />
                                </Grid>
                            ))}
                          </Grid>
                      )
                      : (
                          <div className="row">
                            <div className="col-sm-12 text-center section-b-space mt-5 no-found">
                              <img src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`} className="img-fluid mb-4" alt="" />
                              <h3>Sorry! Couldn`t find the product you were looking For!!!    </h3>
                              <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-solid">continue shopping</Link>
                            </div>
                          </div>
                      )}

          {/* Pagination */}
          {!isLoading && records.length > 0 && pagination && pagination.totalPages > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2, width: '100%' }}>
                <Stack spacing={2}>
                  <Pagination
                      count={pagination.totalPages || 1}
                      page={offsetState || 1}
                      onChange={handlePageChange}
                      color="primary"
                      size="large"
                  />
                </Stack>
              </Box>
          )}

          <Box>&nbsp;<br />&nbsp;</Box>
        </div>
  );

  const renderProductList = () => (
      <Box mt={2} sx={{ width: "100%", paddingBottom: '100px' }}>

        <Box className="credits-display-banner" mb={3} mt={2}>
          <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
            <Box>
              <H4 fontSize={14} color="textSecondary">Available Credits (Buy more using Shopana Marketplace App)</H4>
              <H2 fontSize={24} fontWeight="bold" color="primary">
                {tryonCredits ? tryonCredits.balance || 0 : 0}
              </H2>
            </Box>
          </Box>
        </Box>

        <CustomFlexBox mt={2} sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: 1,
        }}>
          <Box width="35%">
            <SellerProductStatusSelector
                onStatusSelect={setProductStatus}
                productstatus={productStatusState}
            />
          </Box>
          
          <Box width="65%">
            <Box pb={2}>
              <span style={{ paddingRight: "2px" }}>
                <Button 
                  color={activeFilterState === "all" ? "primary" : "secondary"} 
                  size="small" 
                  variant={activeFilterState === "all" ? "contained" : "outlined"} 
                  onClick={() => setActiveFilter("all")}
                >
                  All
                </Button>
              </span>
              <span style={{ paddingRight: "2px" }}>
                <Button 
                  color={activeFilterState === "active" ? "primary" : "secondary"} 
                  size="small" 
                  variant={activeFilterState === "active" ? "contained" : "outlined"} 
                  onClick={() => setActiveFilter("active")}
                >
                  Active
                </Button>
              </span>
              <span style={{ paddingRight: "2px" }}>
                <Button 
                  color={activeFilterState === "inactive" ? "primary" : "secondary"} 
                  size="small" 
                  variant={activeFilterState === "inactive" ? "contained" : "outlined"} 
                  onClick={() => setActiveFilter("inactive")}
                >
                  Inactive
                </Button>
              </span>
              <span style={{ paddingRight: "2px" }}>
                <Button
                    color={activeFilterState === "nomodel" ? "primary" : "secondary"}
                    size="small"
                    variant={activeFilterState === "nomodel" ? "contained" : "outlined"}
                    onClick={() => setActiveFilter("nomodel")}
                >No Model
                </Button>
              </span>
            </Box>
          </Box>
        </CustomFlexBox>


        {isLoading ? <MockProductList />
            : records.length > 0
                ? renderResults()
                : renderNoResults()}
      </Box>
  );

  const renderProductEdit = () => {
    switch (productMode) {
      case "ADD":
        return (
            <PrivateProductEditor
                setState={(value, field) => setProductState({
                  ...state,
                  storeProduct: {
                    ...storeProduct,
                    [field]: value,
                  },
                })}
                product={storeProduct}
                categoriesOption={inputOptions}
                addUpdateProductToShopClicked={addUpdateProductToAccountCall}
                addCategoryClicked={handlePage("/products/categories")}
                cancelEdit={() => setState({ productMode: "PREVIEW" })}
            />
        );

      case "EDIT_QUICK":
        return (
            <PrivateProductQuickAddMain
                cancelEdit={() => setState({ productMode: "PREVIEW" })}
                autoClose={() => setState({ productMode: "PREVIEW" })}
            />
        );
      case "EDIT":
      default:
        return (
        <Box mt={2} sx={{ width: "100%" }}>
          <H2>{storeProduct.name}</H2>
          <Box mt={2} mb={2} sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={value}
                  sx={{
                    '& .MuiTab-root': {
                      backgroundColor: 'grey.300',
                    },
                    '& .Mui-selected': {
                      backgroundColor: "primary.100",
                      color: 'white',
                    },
                  }}
                  indicatorColor="primary"
                  onChange={handleTabChange}
                  variant="fullWidth"
                  aria-label="">
                <Tab label="Settings" {...a11yProps(0)} />
                <Tab label="Details" {...a11yProps(1)} />
                <Tab label="Photos" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0} >
            <SellerProductEntryForm
                setState={(value, field) => setProductState({
                  ...state,
                  storeProduct: {
                    ...storeProduct,
                    [field]: value,
                  },
                })}
                symbol={symbol}
                product={storeProduct}
                shop={shop}
                updateProductSettingClicked={updateProductSettingCall}
                cancelEdit={() => setState({ productMode: "PREVIEW" })}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <PrivateProductEditor
                setState={(value, field) => setProductState({
                  ...state,
                  storeProduct: {
                    ...storeProduct,
                    [field]: value,
                  },
                })}
                product={storeProduct}
                categoriesOption={inputOptions}
                addUpdateProductToShopClicked={addUpdateProductToAccountCall}
                addCategoryClicked={handlePage("/products/categories")}
                cancelEdit={() => setState({ productMode: "PREVIEW" })}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <PrivateProductImageMain
                product={storeProduct}
                cancelEdit={() => setState({ productMode: "PREVIEW" })}
            />
          </TabPanel>
        </Box>
        );
    }
  };

  return (
      <Box sx={{ position: 'relative' }}>
        <UnifiedPullToRefresh
          onRefresh={handleRefresh}
          isRefreshing={isLoading}
        >
          <Container>
          {productMode === "PREVIEW" ? (
            renderProductList()
          ) : (
            renderProductEdit(productMode)
          )}
        </Container>
        </UnifiedPullToRefresh>
        
        {/* Floating Action Buttons - outside pull-to-refresh to maintain fixed position */}
        {productMode === "PREVIEW" && (
          <Box sx={{
            position: 'fixed',
            bottom: 70,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1300,
            display: 'flex',
            gap: 1,
            width: 'auto',
            maxWidth: '90vw',
          }}>
            {selectedProducts.length > 0 ? (
              <>
                <Button
                    size="large"
                    color="secondary"
                    variant="contained"
                    onClick={() => setSelectedProducts([])}
                    sx={{
                      boxShadow: 3,
                      minWidth: '80px',
                      whiteSpace: 'nowrap',
                      px: 2,
                    }}
                >
                  Cancel ({selectedProducts.length})
                </Button>
                <Button
                    size="large"
                    color="primary"
                    variant="contained"
                    onClick={handleOpenModelSelector}
                    disabled={isGeneratingTryOn}
                    startIcon={<PhotoCamera />}
                    sx={{
                      boxShadow: 3,
                      minWidth: '180px',
                      whiteSpace: 'nowrap',
                      px: 2,
                      '&:hover': {
                        boxShadow: 6,
                      }
                    }}
                >
                  {isGeneratingTryOn ? 'Generating...' : 'Generate Model Photos'}
                </Button>
              </>
            ) : (
              <>
                <Button
                    size="medium"
                    color="primary"
                    variant="outlined"
                    onClick={handleSelectAll}
                    startIcon={selectedProducts.length === records.length ? <CheckBox /> : <CheckBoxOutlineBlank />}
                    sx={{
                      boxShadow: 2,
                      minWidth: '100px',
                      whiteSpace: 'nowrap',
                      px: 2,
                      backgroundColor: 'white',
                    }}
                >
                  Select All
                </Button>
                <Button
                    size="large"
                    color="primary"
                    variant="contained"
                    onClick={handleProductEdit("EDIT_QUICK", null, true)}
                    sx={{
                      boxShadow: 3,
                      minWidth: '120px',
                      whiteSpace: 'nowrap',
                      px: 2,
                      '&:hover': {
                        boxShadow: 6,
                      }
                    }}
                >
                  Add New Product
                </Button>
              </>
            )}
          </Box>
        )}

        {/* Model Selector Dialog */}
        <ModelTryOnSelector
          open={showModelSelector}
          onClose={handleCloseModelSelector}
          onSelectModel={handleSelectModel}
          models={systemModels}
          isLoading={isLoadingModels}
          isGenerating={isGeneratingTryOn}
        />
      </Box>
  );
};

PrivateProductsMain.defaultProps = {
  isLoading: false,
  serviceError: "",
  reqStatus: "",
  storeProducts: [],
  categoryList: [],
  symbol: CURRENCY,
};

PrivateProductsMain.propTypes = {
  isLoading: PropTypes.bool,
  serviceError: PropTypes.string,
  reqStatus: PropTypes.string,
  storeProducts: PropTypes.arrayOf(PropTypes.object),
  categoryList: PropTypes.arrayOf(PropTypes.object),
  symbol: PropTypes.string,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  getStoreProducts: PropTypes.func.isRequired,
  getStoreProductCategories: PropTypes.func.isRequired,
  addPrivateProduct: PropTypes.func.isRequired,
  updatePrivateProduct: PropTypes.func.isRequired,
  updateProduct: PropTypes.func.isRequired,
  toggleProductActiveStatus: PropTypes.func.isRequired,
};

const privateProductsMain = connect(
  ({ products, bootupInfo, userbootupInfo }) => ({
    bootupInfo,
    symbol: bootupInfo.symbol,
    currency: bootupInfo.symbol,
    shop: bootupInfo.shop,
    reqStatus: products.reqStatus,
    isLoading: products.isLoading,
    serviceError: products.serviceError,
    storeProducts: products.storeProducts,
    categoryList: products.storeProductCategoryList,
    systemModels: products.systemModels || [],
    isLoadingModels: products.isLoadingModels || false,
    isGeneratingTryOn: products.isGeneratingTryOn || false,
    tryonCredits: userbootupInfo.tryonCredits,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(PrivateProductsMain);

export default privateProductsMain;
